/** Copyright (c) 2019 T.Rowe Price. All rights reserved. */

import {
  CLEAR_CMM,
  RECEIVED_CMM_VERIFICATION
} from './ContactMethodMaintenanceActions';

export const contactMethodMaintenanceInitialState = {
  customer: {},
  emailAddresses: [],
  mailingAddresses: [],
  phoneNumbers: []
};

export const contactMethodMaintenanceReducer = (state = {}, action) => {
  if (action.type === RECEIVED_CMM_VERIFICATION) {
    return action.verification;
  }
  if (action.type === CLEAR_CMM) {
    return contactMethodMaintenanceInitialState;
  }
  return state;
};
